import { getFeatureFlags } from 'platform-components/src/components/app-factory/selectors';
import { createSelector } from 'reselect';

import type { ExamsResultsStoreState } from './typings';

export const storeSelector = (store: { examsResults: ExamsResultsStoreState }) => store.examsResults;

export const getLoadingStatus = createSelector(storeSelector, (store) => store.loadingStatus);

export const getSavingResultsStatus = createSelector(storeSelector, (store) => store.savingResultsStatus);

export const getResultsTemplate = createSelector(storeSelector, (store) => store.resultsTemplate);

export const getResultsErrorId = createSelector(storeSelector, (store) => store.errorId);

export const getIsExamsResultsEnabled = createSelector(getFeatureFlags, (featureFlags) => featureFlags?.ogeEgeResults);
